export enum TipoVeiculoEnum {
  UNDEFINED = 'UNDEFINED',
  MOTOCICLETA = 'MOTOCICLETA',
  AUTOMOVEL = 'AUTOMOVEL',
  CAMINHONETE = 'CAMINHONETE',
  CAMIONETA = 'CAMIONETA',
  UTILITARIO = 'UTILITARIO',
  QUADRICICLO = 'QUADRICICLO',
  CARRO_DE_MAO = 'CARRO_DE_MAO',
  CARROCA = 'CARROCA',
  CHARRETE = 'CHARRETE',
  TRICICLO = 'TRICICLO',
  MOTONETA = 'MOTONETA',
  CICLOMOTOR = 'CICLOMOTOR',
  BICICLETA = 'BICICLETA',
  BONDE = 'BONDE',
  SIDE_CAR = 'SIDE_CAR',
  MICROONIBUS = 'MICROONIBUS',
  ONIBUS = 'ONIBUS',
  SEMI_REBOQUE = 'SEMI_REBOQUE',
  CAMINHAO = 'CAMINHAO',
  TRATOR_DE_RODAS = 'TRATOR_DE_RODAS',
  TRATOR_DE_ESTEIRAS = 'TRATOR_DE_ESTEIRAS',
  TRATOR_MISTO = 'TRATOR_MISTO',
  CHASSI_PLATAFORMA = 'CHASSI_PLATAFORMA',
  MOTOR_HOME = 'MOTOR_HOME',
  REBOQUE = 'REBOQUE',
  CAMINHAO_TRATOR = 'CAMINHAO_TRATOR',
}

export type TipoVeiculoEnumType = typeof TipoVeiculoEnum[keyof typeof TipoVeiculoEnum]

const TipoVeiculoCustomLabels: Partial<Record<TipoVeiculoEnumType, string>> = {
  [TipoVeiculoEnum.UNDEFINED]: 'Undefined',
  [TipoVeiculoEnum.MOTOCICLETA]: 'Motocicleta',
  [TipoVeiculoEnum.AUTOMOVEL]: 'Automóvel',
  [TipoVeiculoEnum.CAMINHONETE]: 'Caminhonete',
  [TipoVeiculoEnum.CAMIONETA]: 'Camioneta',
  [TipoVeiculoEnum.UTILITARIO]: 'Utilitário',
  [TipoVeiculoEnum.QUADRICICLO]: 'Quadriciclo',
  [TipoVeiculoEnum.CARRO_DE_MAO]: 'Carro de mão',
  [TipoVeiculoEnum.CARROCA]: 'Carroça',
  [TipoVeiculoEnum.CHARRETE]: 'Charrete',
  [TipoVeiculoEnum.TRICICLO]: 'Triciclo',
  [TipoVeiculoEnum.MOTONETA]: 'Motoneta',
  [TipoVeiculoEnum.CICLOMOTOR]: 'Ciclomotor',
  [TipoVeiculoEnum.BICICLETA]: 'Bicicleta',
  [TipoVeiculoEnum.BONDE]: 'Bonde',
  [TipoVeiculoEnum.SIDE_CAR]: 'Sidecar',
  [TipoVeiculoEnum.MICROONIBUS]: 'Microonibus',
  [TipoVeiculoEnum.ONIBUS]: 'Ônibus',
  [TipoVeiculoEnum.SEMI_REBOQUE]: 'Semi-reboque',
  [TipoVeiculoEnum.CAMINHAO]: 'Caminhão',
  [TipoVeiculoEnum.TRATOR_DE_RODAS]: 'Trator de rodas',
  [TipoVeiculoEnum.TRATOR_DE_ESTEIRAS]: 'Trator de esteiras',
  [TipoVeiculoEnum.TRATOR_MISTO]: 'Trator misto',
  [TipoVeiculoEnum.CHASSI_PLATAFORMA]: 'Chassi de plataforma',
  [TipoVeiculoEnum.MOTOR_HOME]: 'Motor home',
  [TipoVeiculoEnum.REBOQUE]: 'Reboque',
  [TipoVeiculoEnum.CAMINHAO_TRATOR]: 'Caminhão trator'
}

const TipoVeiculoCustomCode: Partial<Record<TipoVeiculoEnumType, number>> = {
  [TipoVeiculoEnum.UNDEFINED]: 0,
  [TipoVeiculoEnum.MOTOCICLETA]: 4,
  [TipoVeiculoEnum.AUTOMOVEL]: 6,
  [TipoVeiculoEnum.CAMINHONETE]: 23,
  [TipoVeiculoEnum.CAMIONETA]: 13,
  [TipoVeiculoEnum.UTILITARIO]: 25,
  [TipoVeiculoEnum.QUADRICICLO]: 21,
  [TipoVeiculoEnum.CARRO_DE_MAO]: 16,
  [TipoVeiculoEnum.CARROCA]: 15,
  [TipoVeiculoEnum.CHARRETE]: 12,
  [TipoVeiculoEnum.TRICICLO]: 5,
  [TipoVeiculoEnum.MOTONETA]: 3,
  [TipoVeiculoEnum.CICLOMOTOR]: 2,
  [TipoVeiculoEnum.BICICLETA]: 1,
  [TipoVeiculoEnum.BONDE]: 9,
  [TipoVeiculoEnum.SIDE_CAR]: 24,
  [TipoVeiculoEnum.MICROONIBUS]: 7,
  [TipoVeiculoEnum.ONIBUS]: 8,
  [TipoVeiculoEnum.SEMI_REBOQUE]: 11,
  [TipoVeiculoEnum.CAMINHAO]: 14,
  [TipoVeiculoEnum.TRATOR_DE_RODAS]: 18,
  [TipoVeiculoEnum.TRATOR_DE_ESTEIRAS]: 19,
  [TipoVeiculoEnum.TRATOR_MISTO]: 20,
  [TipoVeiculoEnum.CHASSI_PLATAFORMA]: 22,
  [TipoVeiculoEnum.MOTOR_HOME]: 26,
  [TipoVeiculoEnum.REBOQUE]: 10,
  [TipoVeiculoEnum.CAMINHAO_TRATOR]: 17
}

export const getTipoVeiculoLabel = (key: TipoVeiculoEnumType) => {
  return TipoVeiculoCustomLabels[key] || key
}

export const getTipoVeiculoCode = (key: TipoVeiculoEnumType) => {
  return TipoVeiculoCustomCode[key] || 0
}
